import { useTranslations } from 'next-intl'

import usePremiumContent, { PremiumBannerType } from '~/hooks/usePremiumContent'

import PremiumContentBanner from './PremiumContentBanner'

export default function PremiumContentBannerArticle() {
  const t = useTranslations('premiumContentBanner')
  const { showPremiumPrompt, buttonText, handleClick } = usePremiumContent()
  if (!showPremiumPrompt) return null

  const componentText = {
    title: t('title'),
    text: t('description'),
    bullets: [t('benefit1'), t('benefit2'), t('benefit3')],
  }

  const clickHandler = (e: React.MouseEvent) =>
    handleClick(e, PremiumBannerType.articleFooter)

  return (
    <PremiumContentBanner
      buttonText={buttonText}
      clickHandler={clickHandler}
      componentText={componentText}
    />
  )
}
